<div class="modal-header">
  <h5 class="modal-title">{{ title }}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>
<div class="modal-body">
  <div class="d-flex align-items-start">
    <p class="mb-0">{{ message }}</p>
  </div>
</div>
<div class="modal-footer d-flex justify-content-end">
  <button type="button" class="btn btn-secondary" [class]="cancelButtonClass" (click)="cancel()">
    {{ cancelText }}
  </button>
  <button type="button" class="btn custom-btn" [class]="confirmButtonClass" (click)="confirm()">
    {{ confirmText }}
  </button>
</div>
